<div>
  @switch (view) {
    @case ('Start') {
      <div>
        <div class="main-container">
          <div class="container">
            <div class="row justify-content-center">
              <div class="col-12">
                <start-button (notify)="onStart($event)"></start-button>
              </div>
            </div>
          </div>
        </div>
        <footerapp></footerapp>
      </div>
    }
    @case ('Test') {
      <div [@enterTrigger]="'fadeIn'">
        <test (notify)="onEnd($event)"></test>
      </div>
    }
    @case ('Result') {
      <div [@enterTrigger]="'fadeIn'">
        <result (notify)="restart($event)"></result>
      </div>
    }
    @default {
      <div>
        <!-- Default -->
      </div>
    }
  }
</div>